// bluaIQ — the signing-failure notice on the PUBLIC contract-signing page.
//
// Presentational and prop-only ON PURPOSE: it takes a copy key and a language,
// uses no router/query/auth hooks, and therefore mounts standalone in the
// Playwright component harness for the real 390px layout check. (jsdom computes
// no layout, so a width assertion there would be a false guarantee — the same
// reasoning as the client_question card.)
//
// It cannot render server text: it receives a KEY, not a message. The copy is
// resolved by signErrorCopy(), and an unrecognized failure maps to a curated
// generic upstream — never to a raw string.

import { AlertTriangle } from 'lucide-react'
import { signErrorCopy, type SignErrorKey } from '../shared/contractSignErrorCopy'

export function ContractSignErrorNotice({
  copyKey,
  isEs,
}: {
  copyKey: SignErrorKey
  isEs: boolean
}) {
  const { title, body } = signErrorCopy(copyKey, isEs)
  return (
    <div
      data-testid="sign-error-notice"
      role="alert"
      className="flex gap-2.5 items-start text-left bg-red-50 border border-red-100 rounded-lg px-3 py-2.5"
    >
      <AlertTriangle size={16} className="shrink-0 mt-px text-red-600" aria-hidden="true" />
      <div className="min-w-0">
        <div data-testid="sign-error-title" className="text-[12px] font-[800] text-red-700 break-words">
          {title}
        </div>
        <div data-testid="sign-error-body" className="text-[11px] font-[600] text-red-600/90 break-words mt-0.5">
          {body}
        </div>
      </div>
    </div>
  )
}
